<template>
    <div>
    <card>
        <template slot="header">
            <h4 class="card-title">Evaluation Details</h4>
        </template>
        <template>
            <nav class="row breadcrumb-tweak">
                <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                        <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/performance">Evaluation List</router-link>
                    </li>
                    <li class="breadcrumb-item active">Evaluation Details</li>
                </ol>
            </nav>
       </template>
       <hr style="margin-top:-10px"/>
        <div class="report-container">
            <img width="190" height="110" src="/static/img/blueprintlogo.png" alt="..." /><br/>
            <br/> 
            <div class="col-md-12  text-center text-dark">
            <h4><b>EMPLOYEE PERFORMANCE EVALUATION FORM</b></h4>
            </div> 
            <div class="col-md-12 report-border-full">
                <div class="row">
                <div class="col-md-6 border-right">
                    Employee Name : <b>{{item.fullname}}</b> 
                    <br/>
                    Position : <b>{{item.position}}</b> 
                    <br/>
                    Department : <b>{{item.department}}</b> 
                    <br/>
                    Review Period : <b>{{getDate(item.supervisor_date_sign)}}</b>
                </div>
                <div class="col-md-6">
                    Employee Number : <b>{{item.employee_no}}</b> 
                    <br/>
                    Immediate Supervisor : <b>{{item.supervisor_name}}</b>  
                    <br/>
                    Department Manager : <b>{{item.department_head}}</b> 
                    <br/>
                    Hired Date : <b>{{item.hire_date}}</b>   
                </div>
                </div>
            </div>
            <br/>
            <div class="col-md-12 report-border-full">
                <div class="col-md-12 ">
                    <div class="row">
                        <div class="col-md-4 text-center"><b>Type of Review</b></div>
                        <div class="col-md-8 p-0">
                            <div class="row">
                                <div class="col-md-6 border-left text-center">
                                   <i class="fa fa-check"></i></span>
                                    <template v-if="item.description != 'Others' ">({{item.description}})</template>
                                    <template v-else>(Others) - {{item.others}}</template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <p>GENERAL RATING - Mark the appropriate category based on the overall rating for this employee. 
                Any rating above or below "Meets expectations" should include a comment.</p>
            <div class="col-md-12 report-border-full">
            <div class="row">
                <div class="col-md-2 border-right text-center">
                    <h4><b>CRITERIA</b></h4>
                </div>
                <div class="col-md-2 border-right">
                    <br/><p>Consistently Exceeds Expectations</p>
                </div>
                <div class="col-md-2 border-right">
                    <br/><p>Exceeds Expectations in Some Areas or Sometimes</p>
                </div>
                <div class="col-md-2 border-right">
                    <br/><p>Meets Expectations</p>
                </div>
                <div class="col-md-2 border-right">
                <br/><p>Does Not Meet Some Expectations</p>
                </div>
                <div class="col-md-2">
                <br/><p>Consistently Falls Below Expectations</p>
                </div>
            </div>
            </div>
            <div class="report-gatter"></div>
        <!-- Performance -->
            <div class="col-md-12 report-border-full">
            <div class="row">
                <div class="col-md-2 border-right text-center"><b>PERFORMANCE</b></div>
                <div class="col-md-2 border-right text-center">5  <span v-if="item.performance_rating == '5'"><i class="fa fa-check"></i></span></div>
                <div class="col-md-2 border-right text-center">4  <span v-if="item.performance_rating == '4'"><i class="fa fa-check"></i></span></div>
                <div class="col-md-2 border-right text-center">3  <span v-if="item.performance_rating == '3'"><i class="fa fa-check"></i></span></div>
                <div class="col-md-2 border-right text-center">2  <span v-if="item.performance_rating == '2'"><i class="fa fa-check"></i></span></div>
                <div class="col-md-2 text-center">1 <span v-if="item.performance_rating == '1'"><i class="fa fa-check"></i></span></div>
            </div>
            </div>
            <div class="col-md-12 report-border-full">
            <div class="row">
                    <div class="col-md-4 border-right">
                        <p class="mt-5"> - Prioritizing assigned task/s, time management, initiative, creativity, adaptability, flexibility, etc. </p>
                    </div>
                    <div class="col-md-8">
                        <p class="mt-3"><b>Comments:</b></p>
                        <p class="justify-content-center" style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.performance_comments}}</p>
                    </div>
            </div>
            </div>
            <!-- Communication -->
            <div class="col-md-12 report-border-full">
                <div class="row">
                    <div class="col-md-2 border-right text-center"><b>COMMUNICATION</b></div>
                    <div class="col-md-2 border-right text-center">5  <span v-if="item.communication_rating == '5'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">4  <span v-if="item.communication_rating == '4'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">3  <span v-if="item.communication_rating == '3'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">2  <span v-if="item.communication_rating == '2'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 text-center">1 <span v-if="item.communication_rating == '1'"><i class="fa fa-check"></i></span></div>
                </div>
                </div>
                <div class="col-md-12 report-border-full">
                <div class="row">
                        <div class="col-md-4 border-right">
                            <p class="mt-5"> - Team skills, relationship, responsiveness to customers, etc </p>
                        </div>
                        <div class="col-md-8">
                            <p class="mt-3"><b>Comments:</b></p>
                            <p class="justify-content-center" style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.communication_comments}}</p>
                        </div>
                </div>
                </div>
                <!-- Adherance -->
            <div class="col-md-12 report-border-full">
                <div class="row">
                    <div class="col-md-2 border-right text-center"><b>ADHERANCE</b></div>
                    <div class="col-md-2 border-right text-center">5  <span v-if="item.adherence_rating == '5'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">4  <span v-if="item.adherence_rating == '4'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">3  <span v-if="item.adherence_rating == '3'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">2  <span v-if="item.adherence_rating == '2'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 text-center">1 <span v-if="item.adherence_rating == '1'"><i class="fa fa-check"></i></span></div>
                </div>
                </div>
                <div class="col-md-12 report-border-full">
                <div class="row">
                        <div class="col-md-4 border-right">
                            <p class="mt-5"> - Confidentiality, attendance, punctuality, reliability, honesty, etc. </p>
                        </div>
                        <div class="col-md-8">
                            <p class="mt-3"><b>Comments:</b></p>
                            <p class="justify-content-center" style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.adherence_comments}}</p>
                        </div>
                </div>
                </div>
                <!-- Adherance -->
            <div class="col-md-12 report-border-full">
                <div class="row">
                    <div class="col-md-2 border-right text-center"><b>A-PLUS VALUES</b></div>
                    <div class="col-md-2 border-right text-center">5  <span v-if="item.aplus_value_rating == '5'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">4  <span v-if="item.aplus_value_rating == '4'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">3  <span v-if="item.aplus_value_rating == '3'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 border-right text-center">2  <span v-if="item.aplus_value_rating == '2'"><i class="fa fa-check"></i></span></div>
                    <div class="col-md-2 text-center">1 <span v-if="item.aplus_value_rating == '1'"><i class="fa fa-check"></i></span></div>
                </div>
                </div>
                <div class="col-md-12 report-border-full">
                <div class="row">
                        <div class="col-md-4 border-right">
                            <p class="mt-5"> - Purpose and commitment, problem solving and environment, accountability, transformative, assessment. </p>
                        </div>
                        <div class="col-md-8">
                            <p class="mt-3"><b>Comments:</b></p>
                            <p class="justify-content-center" style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.aplus_value_comments}}</p>
                        </div>
                </div>
                </div>
                    <!-- ACTION PLANS -->
                    <br/>
                <div class="col-md-12 report-border-full text-center">
                <p class="mt-2"><b>ACTION PLANS- Individual goals set may which can either be in a general performance area or a more direct related job task. 
                    Goals need to be specific , measurable, realistic and time framed.If more than three are appropriate, please attach and additional page.
                </b></p>
                </div>
                <template v-for="(res, i) in item.action_plans">
                <div class="col-md-12 report-border-full">
                    <p style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;"><b>Action Item</b> # {{i+1}} {{res.action_item}}</p>
                </div>
                <div class="col-md-12 report-border-full">
                    <p style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;"><b>Messure of success :</b> {{res.messure_of_success}}</p>
                </div>
                </template>
            <br/>
            <div class="col-md-12 mb-5">
                <span class="font-weight-bold">OVERALL RATING : <span class="badge-danger rounded p-1"> {{item.overall_rating}}</span></span>
                </div>
                <div class="col-md-12 report-border-full">
                <b>Immediate Supervisor's Comments:</b>
                <p style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.supervisor_comments}}</p>
                </div>
                <br/><br/><br/>
    
                <div class="col-md-12 mt-5">
                <!-- SIGNATURE-SECTION -->    
                <div class="row mb-5">
                    <div class="col-md-8">
                    </div>
                        <div class="col-md-4">
                        <br/><br/>
                        <div v-if="item.supervisor_signature === ''">
                                <div class="report-signature-container">    
                                    <br/>  
                                    <p style="color:red">No signature found .</p>
                                </div>   
                        </div> 
                        <div v-else>   
                            <div class="report-signature-container">    
                                <img class="report-signature-control"  :src="item.supervisor_signature" alt="..."/>
                            </div>    
                            <div class="report-printed-control" v-if="item.requester_role_id == '2'">
                                <b><center>{{item.supervisor_name | uppercase}}</center></b>
                            </div>
                            <div class="report-printed-control" v-else-if="item.requester_role_id == '3'">
                                <b><center>{{item.department_head | uppercase}}</center></b>
                            </div>
                            <div class="report-line-divider"></div>
                            <div v-if="item.requester_role_id == '2'">
                                    <center>Supervisor Signature</center>
                            </div>
                            <div v-else-if="item.requester_role_id == '3'">
                                    <center>Department Head Signature</center>
                            </div>
                        </div>   
                    </div>
                    </div>
                    <!--END SIGNATURE SECTION -->
                </div>   
                <div class="col-md-12 report-border-full">
                <b>Employee's Comments:</b>
                <p style="font-family: Arial, Helvetica, sans-serif;font-size:initial;padding: 15px; white-space:pre-line;">{{item.employee_comments}}</p>
                </div>
                <br/><br/><br/>
                <div class="col-md-12 mt-5">
                <!-- SIGNATURE-SECTION -->    
                <div class="row mb-5">
                        <div class="col-md-8">
                        </div>
                        <div class="col-md-4">
                        <br/><br/>
                        <div v-if="item.employee_signature === ''">
                                <div class="report-signature-container">    
                                    <br/>  
                                    <p style="color:red">No signature found .</p>
                                </div>   
                        </div> 
                        <div v-else>   
                            <div class="report-signature-container">    
                                <img class="report-signature-control"  :src="item.employee_signature" alt="..."/>
                            </div>    
                            <div class="report-printed-control"><b><center>{{item.fullname | uppercase}}</center></b></div>
                            <div class="report-line-divider"></div>
                            <center>Employee Signature</center>
                        </div>   
                    </div>
                    </div>
                    <!--END SIGNATURE SECTION -->
                </div>   
        </div>
        <br/> <br/> <br/>
    </card>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
    components: {
        Card,
    },
        data() {
        return {
            item:{}
        }
        },
        created: function () {
            //this.getCurentUser()
            this.getItem()
        },
        methods: {
            getCurentUser() {
                axios.get('api/user')
                    .then(response => {
                    this.users = response.data;
                    if (this.users.role_id != 5 ) {
                            this.$router.push({name: 'Login-Layout'})
                    }
                    })
                .catch(error => {  console.log(error.response)  });
                },
    
                    getItem(){
                    axios.get('api/evaluation/' + this.$route.params.id + '/' + this.$route.params.employee_id)
                        .then(resp => 
                            {
                                this.item = resp.data
                            }
                        );
                },
        },
    }
    </script>
        


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-performance/todo-performance-details.vue